'use client';

import { useEffect } from 'react';
import { sendErrorLog } from '@/utils/http';

const QUEUE_KEY = 'errorQueue';
const RETRY_INTERVAL_MS = 30_000;

function buildPayload(item) {
    const errcode = item?.errcode || 'unknown';
    const message = item?.message || 'Ismeretlen hiba';
    const stack = `errtype: ${item?.errtype || 'unknown'} | errfield: ${item?.errfield || ''} | http_status: ${item?.http_status || ''} | source: ${item?.source || 'queued'} | time: ${item?.time || new Date().toISOString()}`;

    return {
        message: `Backend API Error [${errcode}]: ${message}`,
        stack,
        url: item?.url || 'unknown',
        useragent: typeof navigator !== 'undefined' ? navigator.userAgent : 'SSR',
        source: 'error-queue-retry'
    };
}

function flushQueue() {
    if (typeof window === 'undefined') return;
    let queue;
    try {
        queue = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
    } catch (_) {
        queue = [];
    }

    if (!Array.isArray(queue) || queue.length === 0) return;

    const remaining = [];
    let pending = queue.length;

    const finalize = () => {
        if (pending > 0) return;
        try {
            localStorage.setItem(QUEUE_KEY, JSON.stringify(remaining));
        } catch (_) {
            // best-effort only
        }
    };

    queue.forEach((item) => {
        const payload = buildPayload(item);
        sendErrorLog({ params: payload })
            .then(() => {
                pending -= 1;
                finalize();
            })
            .catch(() => {
                remaining.push({ ...item, retry_count: (item.retry_count || 0) + 1 });
                pending -= 1;
                finalize();
            });
    });
}

export default function ErrorQueueRetry() {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        flushQueue();

        const handleOnline = () => flushQueue();
        const intervalId = window.setInterval(() => flushQueue(), RETRY_INTERVAL_MS);
        window.addEventListener('online', handleOnline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.clearInterval(intervalId);
        };
    }, []);

    return null;
}
